import React, { Component } from "react";
import { Hub } from "aws-amplify";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import _ from "lodash";
import ReactPasswordStrength from 'react-password-strength';
import {
  loginSuccess,
  cognitoLoginSuccess,
  cognitoLoginFail,
  logout,
} from "../../actions/auth";
import { getUserInfo } from "../../actions/settings";
import { changeUserAttribute } from "../../actions/auth";
import {
  Form
} from "react-bootstrap";
// API Urls
import APIUrls from "../../constants/ApiUrls";
import { APIManager } from "../../utils/api";
import LoaderButton from "../../components/LoaderButton";
import "./Signup.scss";
// Utils
import { codeAndParamsFromUrl, paramsFromBase64Url, addEventNameToEndpoint } from "../../utils/common";
import { isOnboarding } from "../../utils/userState";

// Assets
import imgSignup from '../../assets/images/ilustration-signup-gartner.png';
import imgSignupInvited from '../../assets/images/ilustration-signup-invited.png';
import imgCamelLogo from '../../assets/images/content-camel-logo.png';

const ValidationRules = {
  MinimumLength: 12,
  RequireLowercase: false,
  RequireNumbers: true,
  RequireSymbols: false,
  RequireUppercase: true,
  MinimumScore: 4
};

const FormType = {
  LOGIN: 0,
  SIGNUP: 1,
  INVITED_SIGNUP: 2,
  PARTNER_SIGNUP: 3
};

const SIGNUP_PATHS = {
  LOGIN: "login",
  SIGNUP: "signup",
  INVITED_USER: "signup-invited-user",
  PARTNER_SIGNUP: "signup-partner-owner"
}


class Signup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: "",
      fullName: "",
      company: "",
      password: "",
      // confirmPassword: "",
      GAClientID: "no-gaclientid",
      GCLID: "no-gclid",
      tenant: null,
      formType: this.getFormType(props),
      error: null,
      invitedInfo: {},
      isHuman: false
    };

    this.recaptchaRef = React.createRef();
  }

  componentDidMount() {    
    this.setFormType(this.props);
  }

  getSnapshotBeforeUpdate(prevProps, prevState) {
    if (!_.isEqual(this.props.location, prevProps.location)) {
      this.setFormType(this.props);
    }

    return null;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
  }

  /**
   * Given the current props, return the form type
   * @param {Object} props 
   */
  getFormType = (props) => {
    const { pathname } = props.location;
    let formType = FormType.LOGIN;
    if (pathname.includes(SIGNUP_PATHS.INVITED_USER)) {
      formType = FormType.INVITED_SIGNUP;
    } else if (pathname.includes(SIGNUP_PATHS.SIGNUP)) {
      formType = FormType.SIGNUP
    }
    return formType;
  }

  setFormType = async props => {
    const { pathname } = props.location;
    
    // handle the invited users
    if (pathname.includes(SIGNUP_PATHS.INVITED_USER) || pathname.includes(SIGNUP_PATHS.PARTNER_SIGNUP)) {
      const { search, hash } = this.props.location;
      if (!search) {
        this.props.history.push('/login');
        return;
      }
      
      let searchString = search + (hash || '');
      let params;
      if (pathname.includes(SIGNUP_PATHS.PARTNER_SIGNUP)) {
        this.props.Auth.signOut();
        this.props.logout();
        params = paramsFromBase64Url(searchString);
      } else {
        params = codeAndParamsFromUrl(searchString);
      }
      const { code: oldPassword, name: fullName, userId, userPoolId, region, email } = params;
      // we set username here to email even though username can be extracted from string
      // but query param parsing can result in issues (like spaces) bc username is not escaped
      const username = email;

      const invitedInfo = {
        oldPassword,
        fullName,
        username,
        userId,
        userPoolId,
        region,
        email
      };

      await this.setUpCognito(email);

      if (pathname.includes('signup-invited-user')) {
        this.setState({
          formType: FormType.INVITED_SIGNUP,
          invitedInfo,
          fullName,
          email
        });
      } else {
        this.setState({
          formType: FormType.PARTNER_SIGNUP,
          invitedInfo,
          fullName: '',
          email
        });
      }
    } else if (pathname.includes('signup')) {
      this.setState({ formType: FormType.SIGNUP });
    } else {
      this.setState({ formType: FormType.LOGIN });
    }
  }

  validateForm() {
    const { formType } = this.state;
    
    switch (formType) {
      case FormType.SIGNUP:
        return (
          this.state.email.length > 0 &&
          this.state.fullName &&
          this.state.fullName !== '' &&
          !this.state.fullName.includes("http") && 
          this.state.company &&
          this.state.company !== '' &&
          !this.state.company.includes("http") && 
          this.state.password.length >= ValidationRules.MinimumLength
          // this.state.password === this.state.confirmPassword
        );
      case FormType.LOGIN:
        return (
          this.state.email.length > 0 &&
          this.state.password.length > 0
        );
      case FormType.INVITED_SIGNUP:
      case FormType.PARTNER_SIGNUP:
        return (
          this.state.email.length > 0 &&
          this.state.fullName &&
          this.state.fullName !== '' &&
          this.state.password.length >= ValidationRules.MinimumLength
          // this.state.password === this.state.confirmPassword
        )
      default:
        return (
          this.state.email.length > 0 &&
          this.state.password.length >= ValidationRules.MinimumLength
        );
    }
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSignup = async event => {
    // event.preventDefault();

    // if (this.state.fullName.split(' ').length > 2) {
    //   toast.error('Please make sure you don’t leave an unescaped space.', {
    //     position: toast.POSITION.TOP_RIGHT
    //   });

    //   return false;
    // }
  
    this.setState({ isLoading: true, error: null });
  
    try {
      // register and create a new tenant with pending confirmation
      const tenant = await this.register({
        email: this.state.email,
        fullName: this.state.fullName,
        company: this.state.company,
        password: this.state.password,
        name: this.state.name,
        GAClientID: this.state.GAClientID,
        GCLID: this.state.GCLID
      });

      // const credentials = await this.props.Auth.currentCredentials();
      // addEventNameToEndpoint(this.props.Analytics, '_userauth.sign_up');

      // this.props.Analytics.record({
      //   name: '_userauth.sign_up',
      //   attributes: {
      //     tenantId: tenant.tenantId
      //   }
      // })
      // .then(res => {
      //   console.log('sign up event tracking: ', res);
      // })
      // .catch(error => console.log('signup event tracking error: ', error));
      
      if (tenant) {
        this.props.history.push({
          pathname: '/confirm',
          state: {
            user: tenant
          }
        });
      }
    } catch (e) {
      this.setState({ error: e.message, isLoading: false });
      // toast(e.message, { containerId: 'error' });
      toast.error(e.message, {
        position: toast.POSITION.TOP_RIGHT
      });
    }
  }

  /**
   * The invited signup for users that have been added to an existing account.
   * Handle the user activating their account.
   * @param {Object} e 
   */
  handleInvitedSignup = (e) => {
    e.preventDefault();

    const { password, invitedInfo, formType, fullName } = this.state;

    // handle special chars that need to be decoded in 
    // CODE param handed as old password
    let decodedPassword = invitedInfo.oldPassword;
    try {
      decodedPassword = decodeURIComponent(decodedPassword);
    } catch (error) {
      console.error("decodeURIComponent failed for user signup");
      // but continue
    }
    this.props.Auth.signIn(invitedInfo.username, decodedPassword)
    .then(user => {
      if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        // const { requiredAttributes } = user.challengeParam; // the array of required attributes, e.g ['email', 'phone_number']
        this.props.Auth.completeNewPassword(
          user,               // the Cognito User Object
          password,       // the new password
          // OPTIONAL, the required attributes
          {
            email: invitedInfo.email
          }
        ).then(async user => {
          // at this time the user is logged in if no MFA required
          const tenant = await this.setUpCognito(invitedInfo.email);
          this.props.setUser(user);
          user.attributes = {
            ...user.challengeParam.userAttributes
          };

          this.props.cognitoLoginSuccess(user);
          this.props.getUserInfo();

          addEventNameToEndpoint(this.props.Analytics, `${user.challengeParam.userAttributes['custom:role']}-auth-confirmed`);
          this.props.Analytics.record({
            name: `${user.challengeParam.userAttributes['custom:role']}-auth-confirmed`,
            attributes: {
              tenantId: tenant.tenantId,
              userId: invitedInfo.userId
            }
          })
          .then(res => {
            // console.log('confirmation event tracking: ', res);
          })
          .catch(error => console.log('confirmation event tracking error: ', error));

          const isAdmin = _.get(user, "challengeParam.userAttributes['custom:role']", '') === 'admin';
          this.props.changeUserAttribute({ name: 'name', value: fullName, authAttribute: true });

          this.props.history.push('/onboarding');
        }).catch(e => {
          toast.error('Failed to signup: ' + e.message, {
            position: toast.POSITION.TOP_RIGHT
          });
        });
      } else {
        // other situations
      }
    }).catch(e => {
      toast.error('Failed to signup: ' + typeof e === 'string' ? e : e.message, {
        position: toast.POSITION.TOP_RIGHT
      });
    });
  }

  handleLogin = async event => {
    event.preventDefault();
    this.setState({ isLoading: true, error: null });

    try {
      const { user, tenantUser } = await this.authWithCognito(this.state.email, this.state.password);
      this.props.setUser(tenantUser);
      this.props.getUserInfo();

      if (isOnboarding(user)) {
        this.props.history.push('/onboarding');
      } else {
        this.props.history.push('/dashboard');
      }
    } catch (e) {
      // const user = await Amplify.Auth.signIn(this.state.email, this.state.password);
      const error = typeof e === 'string' ? e : (e.response ? e.response.data.data : e.message);
      this.setState({ error, isLoading: false });
      this.props.cognitoLoginFail();

      toast.error('Login error: ' + error, {
        position: toast.POSITION.TOP_RIGHT
      });

      if (e.message === 'User is not confirmed.') {
        this.props.history.push({
          pathname: '/confirm',
          state: {
            user: this.state.tenant
          }
        });
      }
    }
  }

  fetchGoogleAuthUrl = async () => {
    try {
      await APIManager.Instance.call("GET", APIUrls.googleAuthUrl);
    } catch (e) {
      this.setState({ error: e.response.data.data || e.response.data.message, isLoading: false });
      toast.error(e.response.data.data || e.response.data.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return null;
    }
  }

  setUpCognito = async (email) => {
    // lookup tenant for given email (we have to make emails URI safe)
    const data = await APIManager.Instance.call("GET", APIUrls.getTenant(email));
    const { tenant } = data; // TODO clean up return values
    this.props.loginSuccess(tenant);
    this.setState({ tenant });

    return tenant;
  }

  authWithCognito = async (email, password) => {
    const tenantUser = await this.setUpCognito(email);
    const user = await this.props.Auth.signIn(email, password);
    if (user) {
      this.props.cognitoLoginSuccess(user);
    }

    await this.listenWithAuthHub(tenantUser);
    return {
      tenantUser,
      user
    };
  }

  register = async (registrationInfo) => {
    // lookup tenant for given email
    const params = {
      email: registrationInfo.email,
      name: registrationInfo.fullName,
      companyName: registrationInfo.company,
      password: registrationInfo.password,
      GAClientID: registrationInfo.GAClientID,
      GCLID: registrationInfo.GCLID
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
      crossdomain: true
    };

    try {
      const response = await APIManager.Instance.call("POST", APIUrls.registerOwner, config, params);
      const tenant = response; // TODO clean up return values
      this.props.loginSuccess(tenant); 

      return tenant;
    } catch (e) {
      this.setState({ error: e.response.data.data || e.response.data.message, isLoading: false });
      // toast('Wow so easy !', { containerId: 'A' });
      toast.error(e.response.data.data || e.response.data.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return null;
    }
  }

  listenWithAuthHub = async (tenantUser) => {
    Hub.listen("auth", async ({ payload: { event, data } }) => {
      switch (event) {
        case "signIn":
          // this.props.loginSuccess(tenantUser);
          // this.props.getUserInfo();
          // if (_.get(tenantUser, "attributes['custom:state']") === 'onboarding') {
          //   this.props.history.push('/onboard');
          // } else {
          //   this.props.history.push('/dashboard');
          // }
          break;
        case "signOut":
          // this.props.logout();
          break;
        default:
          break;
      }
    });
  }

  handlerRecaptchaChange = (value) => {
    this.setState({ isHuman: true });

    this.handleSignup();
  }

  handleExcuteRecaptcha = (event) => {
    event.preventDefault();

    this.setState({
      GAClientID: event.target.GAClientID.value,
      GCLID: event.target.GCLID.value
    });

    this.recaptchaRef.current.execute();
  }

  renderSignupForm() {
    const {
      email,
      // confirmPassword,
      company,
      // GAClientID,
      // GCLID,
      isLoading,
      fullName
    } = this.state

    return (
      <Form className="signup-form" onSubmit={this.handleExcuteRecaptcha} autoComplete='off'>
        <p>Sign up now with email</p>
        <Form.Group controlId="email" size="smz">
          <Form.Label>Email</Form.Label>
          <Form.Control
            autoFocus
            type="email"
            name="email"
            placeholder="yourwork@email.com"
            value={email}
            onChange={this.handleChange}
            autoComplete="email"
          />
        </Form.Group>
        <input type="hidden" value="" />
        <Form.Group controlId="fullName" size="sm">
          <Form.Label>Full Name</Form.Label>
          <Form.Control
            autoFocus
            type="text"
            name="fullName"
            placeholder="Full Name"
            value={fullName}
            onChange={this.handleChange}
          />
        </Form.Group>
        <Form.Group controlId="company" size="sm">
          <Form.Label>Company</Form.Label>
          <Form.Control
            autoFocus
            type="text"
            name="companyName"
            placeholder="Company Name"
            value={company}
            onChange={this.handleChange}
          />
        </Form.Group>
        <Form.Group controlId="password" size="sm">
          <Form.Label>Password</Form.Label>
          <ReactPasswordStrength
            className="customClass"
            minLength={ValidationRules.MinimumLength}
            minScore={ValidationRules.MinimumScore}
            scoreWords={['weak', 'okay', 'good', 'strong', 'stronger']}
            changeCallback={(e) => this.handleChange({ target: { id: 'password', value: e.password } })}
            inputProps={{ name: "password_input", className: "form-control", autoComplete: "new-password" }}
          />
        </Form.Group>
        {/* <Form.Group controlId="confirmPassword" size="sm">
          <Form.Label>Confirm Password</Form.Label>
          <Form.Control
            value={confirmPassword}
            onChange={this.handleChange}
            type="password"
          />
        </Form.Group> */}
        {/* Hidden fields for attribution */}
        <Form.Group controlId="GAClientID">
          <Form.Control
            type="hidden"
            name="GAClientID"
            onChange={this.handleChange}
            />
        </Form.Group>
        <Form.Group controlId="GCLID">
          <Form.Control
            type="hidden"
            name="GCLID"
            onChange={this.handleChange}
          />
        </Form.Group>
        <div className="w-100 flex justify-content-center mt-3">
          <ReCAPTCHA
            ref={this.recaptchaRef}
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            onChange={this.handlerRecaptchaChange}
            size="invisible"
          />
        </div>
        <LoaderButton
          block
          size="sm"
          disabled={!this.validateForm()}
          type="submit"
          isLoading={isLoading}
          text="Signup"
          loadingText="Signing up…"
          className="btn-danger"
        />
        <Link to="/login">I already have an account {">"}</Link>
      </Form>
    );
  }

  /**
   * The Invited User sign up form -- for users that have been added to an existing account
   */
  renderInvitedSignupForm() {
    const {
      email,
      password,
      // confirmPassword,
      isLoading,
      fullName,
      formType
    } = this.state

    return (
      <Form className="signup-form" onSubmit={this.handleInvitedSignup}>
        <p>Just create your password and you're all set.</p>
        <Form.Group controlId="email" size="smz">
          <Form.Label>Email</Form.Label>
          <Form.Control
            autoFocus
            type="email"
            placeholder="yourwork@email.com"
            value={email}
            onChange={this.handleChange}
            disabled
          />
        </Form.Group>
        <Form.Group controlId="fullName" size="sm">
          <Form.Label>Full Name</Form.Label>
          <Form.Control
            autoFocus
            type="text"
            placeholder="Full Name"
            value={fullName.split("%20").join(' ')}
            onChange={(e) => this.handleChange({ target: { id: 'fullName', value: e.target.value } })}
          />
        </Form.Group>
        <Form.Group controlId="password" size="sm">
          <Form.Label>Password</Form.Label>
          <ReactPasswordStrength
            className="customClass"
            minLength={ValidationRules.MinimumLength}
            minScore={ValidationRules.MinimumScore}
            scoreWords={['weak', 'okay', 'good', 'strong', 'stronger']}
            changeCallback={(e) => this.handleChange({ target: { id: 'password', value: e.password } })}
            inputProps={{ name: "password_input", autoComplete: "new-password", className: "form-control" }}
            defaultValue={password}
          />
        </Form.Group>
        {/* <Form.Group controlId="confirmPassword" size="sm">
          <Form.Label>Confirm Password</Form.Label>
          <Form.Control
            value={confirmPassword}
            onChange={this.handleChange}
            type="password"
          />
        </Form.Group> */}
        <LoaderButton
          block
          size="sm"
          disabled={!this.validateForm()}
          type="submit"
          isLoading={isLoading}
          text={formType !== FormType.PARTNER_SIGNUP ? "Signup" : "Confirm"}
          loadingText="Signing up…"
          className="btn-danger"
        />
        {formType !== FormType.PARTNER_SIGNUP && <Link to="/login">I'm already an account owner {">"}</Link>}
      </Form>
    );
  }

  renderLoginForm() {
    const { email, password, isLoading } = this.state;
    const environment = process.env.REACT_APP_ENVIRONMENT === "production" ? "" : `[Environment: ${process.env.REACT_APP_ENVIRONMENT}]`; 

    return (
      <Form className="signup-form" onSubmit={this.handleLogin} autoComplete="on">
        <p>Login with email</p>
        <Form.Group controlId="email" size="sm">
          <Form.Label>Email</Form.Label>
          <Form.Control
            autoFocus
            type="email"
            autoComplete="email"
            placeholder="yourwork@email.com"
            value={email}
            onChange={this.handleChange}
          />
        </Form.Group>
        <Form.Group controlId="password" size="sm">
          <Form.Label>Password</Form.Label>
          <Form.Control
            autoFocus
            type="password"
            autoComplete="current-password"
            placeholder=""
            value={password}
            onChange={this.handleChange}
          />
        </Form.Group>
        <LoaderButton
          block
          size="sm"
          disabled={!this.validateForm()}
          type="submit"
          isLoading={isLoading}
          text="Sign In"
          loadingText="Signing In…"
          className="btn-danger"
        />
        <Link to="/signup">No account yet? Sign up now {">"}</Link><br />
        <Link to="/forgot-password">Forgot password? {">"}</Link><br /><br />
        <span>{environment}</span>
      </Form>
    );
  }

  renderFormByType = () => {
    const { formType } = this.state;

    switch (formType) {
      case FormType.LOGIN:
        return this.renderLoginForm();
      case FormType.SIGNUP:
        return this.renderSignupForm();
      case FormType.INVITED_SIGNUP:
      case FormType.PARTNER_SIGNUP:
        return this.renderInvitedSignupForm();
      default:
        return this.renderSignupForm();
    }
  }

  renderLeftPanelImage = (formType) => {
    switch (formType) {
      case FormType.INVITED_SIGNUP:
        return (<img src={imgSignupInvited} alt="you are invited" />);  
      case FormType.PARTNER_SIGNUP:
        return (<img src={imgSignupInvited} alt="activate your account" />);  
      default:
        return (<img src={imgSignup} alt="signup to Content Camel" />);
    }
  }

  render() {
    const { formType } = this.state;
    const headerMessage = formType === FormType.LOGIN ? "Access your account here." : "We're happy to see you." 
    return (
      <div className="Signup">
        <div className="left-panel"> 
          { this.renderLeftPanelImage(formType) }
          {/* { FormType.INVITED_SIGNUP === formType 
            ? <img src={imgSignupInvited} alt="you are invited" />
            : <img src={imgSignup} alt="signup to Content Camel" />
          } */}
        </div>
        <div className="right-panel">
          <img className="camel-logo" src={imgCamelLogo} alt="content camel logo"/>
            <div className="signup-wrapper">
              {formType !== FormType.INVITED_SIGNUP ?
                <div>
                  <div className="signup-title">
                    { FormType.PARTNER_SIGNUP === formType 
                    ? <h3>Hi Sumo-ling <span role="img" aria-label="hand-image">👋</span> {headerMessage}</h3> 
                    : <h3>Hi there <span role="img" aria-label="hand-image">👋</span> {headerMessage}</h3>
                    }
                    {/* <p>Get a free 14-days trial</p> */}
                  </div>
                  {/* <p>Continue with a Google account</p>
                  <Button className="btn-google">Sign Up With Google</Button>
                  <p>Continue with a LinkedIn account</p>
                  <Button className="btn-google">Sign Up With LinkedIn</Button> */}
                </div>
                :
                <div>
                  <div className="signup-title">
                    <h3>Hi there <span role="img" aria-label="hand-image">👋</span> Activate your account here.</h3>
                  </div>
                </div>
              }
              {this.renderFormByType()}
            </div>
          {/* {error && <p className="error">{error}</p>} */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.tenant,
  Auth: state.auth.Auth,
  Analytics: state.auth.Analytics
});

const mapDispatchToProps = dispatch => 
  bindActionCreators({
    loginSuccess,
    logout,
    getUserInfo,
    cognitoLoginSuccess,
    cognitoLoginFail,
    changeUserAttribute
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Signup);
